<template>
  <div class="navbar-item">
    <div class="buttons">
      <router-link
        v-if="isAuth"
        class="button is-primary"
        active-class="is-active"
        :to="{name: 'user'}"
        exact
      >
        <span class="icon is-small">
          <i class="mdi mdi-account-circle"></i>
        </span>
        <span>Кабинет</span>
      </router-link>
      <!-- INFO Регистрация закомменчена -->
      <!-- <button v-else class="button is-primary" @click="registrationModal">
        <span>Регистрация</span>
      </button>-->
      <button v-if="isAuth" class="button is-primary" @click="onLogout">
        <span class="icon is-small">
          <i class="mdi mdi-exit-to-app"></i>
        </span>
        <span>Выход</span>
      </button>
      <button v-else class="button is-primary" @click="loginModal">
        <span class="icon is-small">
          <i class="mdi mdi-account-outline"></i>
        </span>
        <span>Вход</span>
      </button>
    </div>
  </div>
</template>

<script>
import LoginModal from "@/components/layout/LoginModal";
import RegistrationModal from "@/components/layout/RegistrationModal";
import { mapGetters } from "vuex";

export default {
  name: "Login",
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
    },
    loginModal() {
      this.$buefy.modal.open({
        parent: this,
        component: LoginModal,
        hasModalCard: true
      });
    },
    registrationModal() {
      this.$buefy.modal.open({
        parent: this,
        component: RegistrationModal,
        hasModalCard: true
      });
    }
  },
  computed: {
    ...mapGetters(["isAuth"])
  }
};
</script>

<style>
</style>
